import type { ReportsTranslation } from './types';

/** Hindi. Pending review by native speakers. */
export const reportsHi: ReportsTranslation = {
  nav: 'रिपोर्ट',
  title: 'रिपोर्ट',
  description:
    'बातचीत कैसी रही: मात्रा, व्यक्ति को सौंपना, समाधान और फ़ीडबैक, साथ में आपके प्लान का उपयोग और इनवॉइस। केवल कुल आँकड़े, संदेशों की सामग्री कभी नहीं।',
  export: 'CSV एक्सपोर्ट करें',
  exported: 'CSV रिपोर्ट डाउनलोड हो गई।',
  loading: 'रिपोर्ट लोड हो रही है',
  tabs: {
    quality: 'सेवा की गुणवत्ता',
    teams: 'टीम गतिविधि',
    tickets: 'टिकट',
    ai: 'AI उपयोग',
    billing: 'बिलिंग',
  },
  withheld: 'रोका गया',
  smallSample: 'छोटा नमूना',
  fewer: 'रोका गया: {{count}} से कम',
  rateOf: '{{count}} में से {{rate}}',
  previousValue: 'पिछली अवधि: {{count}}',
  responses: 'उत्तर: {{count}}',
  basedOn: 'मापी गई बातचीत: {{count}}',
  outOfFive: '{{value}} / 5',
  privacy:
    'निजता की रक्षा के लिए, {{count}} से कम बातचीत या उत्तरों पर आधारित संख्या रोकी जाती है, और जहाँ कुल संख्या उसे उजागर कर दे वहाँ अगली सबसे छोटी संख्या भी।',
  rangeNote: '{{from}} से {{to}} तक, दिन {{zone}} के अनुसार।',
  partial: 'इस अवधि का कुछ हिस्सा रिपोर्ट रिकॉर्डिंग शुरू होने से पहले का है, इसलिए वह गिना नहीं जाता।',
  partialSince: 'रिपोर्ट की रिकॉर्डिंग {{date}} को शुरू हुई; उससे पहले की बातचीत नहीं गिनी जाती।',
  filters: {
    range: 'तारीख़ें',
    ranges: {
      '7d': 'पिछले 7 दिन',
      '30d': 'पिछले 30 दिन',
      '90d': 'पिछले 90 दिन',
      custom: 'अपनी अवधि',
    },
    from: 'से',
    to: 'तक',
    team: 'टीम',
    allTeams: 'सभी टीमें',
    channel: 'चैनल',
    allChannels: 'सभी चैनल',
  },
  tiles: {
    conversations: 'बातचीत',
    handoffs: 'व्यक्ति को सौंपी गई',
    resolved: 'हल हुई',
    feedback: 'ग्राहक फ़ीडबैक',
    aiResolved: 'AI द्वारा हल',
    firstResponse: 'पहले उत्तर का माध्य',
    resolution: 'समाधान के समय का माध्य',
  },
  chart: {
    title: 'प्रति दिन बातचीत',
    summary:
      '{{from}} से {{to}} तक प्रति दिन बातचीत का रेखा चार्ट, पिछली अवधि के साथ। नीचे की तालिका में हर दिन है।',
    current: 'यह अवधि',
    previous: 'पिछली अवधि ({{from}} – {{to}})',
    currentShort: 'यह अवधि',
    previousShort: 'पिछली अवधि',
    caption: '{{count}} से कम बातचीत वाले दिन रोके जाते हैं और ख़ाली जगह के रूप में दिखते हैं।',
    table: 'संख्याएँ तालिका में दिखाएँ',
    date: 'दिन',
  },
  reasons: {
    title: 'बातचीत व्यक्ति को क्यों सौंपी गई',
    empty: 'इस अवधि में कोई सौंपना नहीं।',
    reason: 'कारण',
    count: 'बातचीत',
    names: {
      customer_request: 'ग्राहक ने व्यक्ति से बात करनी चाही',
      ai_unavailable: 'AI मॉडल उपलब्ध नहीं था',
      ai_blocked: 'AI का उत्तर रोका गया',
      ai_limit: 'AI की सीमा या बजट पूरा हुआ',
      ai_stopped: 'AI उत्तर रोके गए थे',
      no_agent: 'कोई AI एजेंट प्रकाशित नहीं था',
      assist_mode: 'AI केवल उत्तर सुझाता है',
      channel_ai_off: 'इस चैनल पर AI जवाब नहीं देता',
      staff_takeover: 'किसी व्यक्ति ने सँभाला',
      staff_reply: 'किसी व्यक्ति ने उत्तर दिया',
      staff_assign: 'किसी व्यक्ति को सौंपी गई',
      staff_release: 'कतार में वापस भेजी गई',
      authority_assignment: 'Chatwoot में सौंपी गई',
      authority_handoff: 'Chatwoot में हस्तांतरित',
      human_reply: 'Chatwoot में किसी व्यक्ति ने उत्तर दिया',
      return_to_ai: 'AI को लौटाई गई',
      unknown: 'दर्ज नहीं',
    },
  },
  quality: {
    title: 'जो चैट ठीक नहीं रहीं',
    description:
      'ग्राहक जिन्होंने लिखा और एक घंटे में जवाब नहीं मिला, कोई जवाब देने वाला न होने पर संपर्क फ़ॉर्म से छोड़े गए संदेश, और बंद चैट जो फिर से खोली गईं।',
    missed: 'छूटी हुई चैट',
    missedNote: 'उन {{count}} चैट में से {{rate}} जिनमें ग्राहक ने लिखा',
    offlineMessages: 'संपर्क फ़ॉर्म के संदेश',
    offlineMessagesNote: 'जब कोई जवाब देने वाला नहीं था, तब छोड़े गए',
    reopened: 'फिर से खोलने की दर',
    reopenedNote: '{{count}} बंद चैट में से, जो फिर खोली गईं',
  },
  tickets: {
    title: 'टिकट',
    created: 'बनाए गए',
    createdNote: 'इस अवधि में खोले गए',
    closed: 'बंद किए गए',
    closedNote: 'इस अवधि में खुले, और फिर बंद हुए',
    openNow: 'अभी खुले',
    openNowNote: 'खुले या ग्राहक के इंतज़ार में, चाहे कभी भी खोले गए हों',
    closeMedian: 'बंद होने का औसत (माध्यिका) समय',
    byPriority: 'प्राथमिकता के अनुसार',
    bySource: 'स्रोत के अनुसार',
    priority: 'प्राथमिकता',
    source: 'स्रोत',
    count: 'टिकट',
    priorities: {
      urgent: 'अत्यावश्यक',
      high: 'ऊँची',
      medium: 'मध्यम',
      low: 'कम',
      none: 'कोई प्राथमिकता नहीं',
    },
    sources: {
      offline_form: 'संपर्क फ़ॉर्म',
      staff: 'टीम',
      automation: 'ऑटोमेशन',
      email: 'ईमेल',
    },
    emptyList: 'इस अवधि में कोई टिकट नहीं।',
    empty: {
      title: 'इस तारीख़ सीमा में कोई टिकट नहीं',
      description: 'टिकट संपर्क फ़ॉर्म, ईमेल, आपकी टीम और ऑटोमेशन से आते हैं। कोई दूसरी तारीख़ सीमा आज़माएँ।',
    },
  },
  commerce: {
    title: 'ऑर्डर और रिफ़ंड',
    description: 'बातचीत में दिए गए ऑर्डर और लौटाए गए रिफ़ंड, हर मुद्रा के अनुसार।',
    empty: 'इस अवधि में कोई ऑर्डर या रिफ़ंड नहीं।',
    currency: 'मुद्रा',
    orders: 'ऑर्डर',
    revenue: 'भुगतान हुआ',
    refunds: 'रिफ़ंड',
    refunded: 'लौटाया गया',
  },
  teams: {
    title: 'कतार का प्रदर्शन',
    description: 'टीमें, उनकी कतार की बातचीत के अनुसार।',
    team: 'टीम',
    conversations: 'बातचीत',
    firstResponse: 'पहले उत्तर का माध्य',
    handoffRate: 'सौंपने की दर',
    feedback: 'ग्राहक फ़ीडबैक',
    unnamed: 'बिना नाम की टीम',
    none: 'कोई टीम नहीं',
  },
  channels: {
    title: 'चैनल',
    channel: 'चैनल',
    unknown: 'अज्ञात चैनल',
  },
  replyTargets: {
    title: 'जवाब के समय के लक्ष्य',
    description:
      'किसी व्यक्ति ने कितनी बार ब्रांड के जवाब-समय लक्ष्य के भीतर जवाब दिया। लक्ष्य तब गिना जाता है जब उसकी घड़ी रुकती है; जो घड़ियाँ किसी व्यक्ति के जवाब के बिना रुकीं, वे अलग गिनी जाती हैं, चूके हुए लक्ष्य के रूप में नहीं।',
    met: 'पूरे हुए लक्ष्य',
    metNote: 'लोगों के {{count}} जवाबों में से',
    missed: 'चूके हुए लक्ष्य',
    missedNote: 'लक्ष्य के बाद आए जवाब',
    firstReply: 'पहले जवाब तक का मध्य समय',
    firstReplyNote: 'कामकाजी समय, स्नूज़ का समय छोड़कर। मापे गए जवाब: {{count}}',
    stopped: 'बिना जवाब के रुकीं',
    stoppedNote: 'AI ने चैट वापस ले ली, या वह हल हो गई',
    byPriority: 'प्राथमिकता के अनुसार',
    byDay: 'दिन के अनुसार',
    replies: 'जवाब',
    metShare: 'पूरे हुए',
    none: 'इस अवधि में जवाब-समय की कोई घड़ी नहीं रुकी।',
    recordingSince: 'जवाब-समय लक्ष्य {{date}} से दर्ज किए जा रहे हैं।',
    notRecorded:
      'अभी कुछ दर्ज नहीं हुआ। नतीजे तब दिखेंगे जब कोई व्यक्ति ऐसी बातचीत में जवाब देगा जिसका जवाब-समय लक्ष्य है।',
  },
  offers: {
    title: 'एक समय में एक व्यक्ति को पेश की गई चैट',
    description:
      'इस अवधि में किए गए ऑफ़र: स्वीकार किए गए, अस्वीकार किए गए या जिनका समय खत्म हुआ, लोगों ने क्यों अस्वीकार किया, और वे हैंड-ऑफ़ जिन्हें किसी ने नहीं लिया।',
    accepted: 'स्वीकार किए गए',
    acceptedNote: 'जवाब दिए गए या समय खत्म हुए {{count}} ऑफ़र में से',
    declined: 'अस्वीकार किए गए',
    expired: 'समय खत्म हुआ',
    acceptTime: 'स्वीकार करने का मध्य समय',
    acceptTimeNote: 'स्वीकार किए गए ऑफ़र: {{count}}',
    leftInQueue: 'कतार में रह गईं',
    leftInQueueNote: '{{count}} में से वे हैंड-ऑफ़ जिन्हें किसी ने स्वीकार नहीं किया',
    declineReasons: 'लोगों ने क्यों अस्वीकार किया',
    reason: 'कारण',
    declinedCount: 'अस्वीकार किए गए ऑफ़र',
    noDeclines: 'इस अवधि में कोई ऑफ़र अस्वीकार नहीं हुआ।',
    reasons: {
      at_capacity: 'बहुत ज़्यादा चैट',
      not_my_area: 'उनका क्षेत्र नहीं',
      going_offline: 'ऑफ़लाइन जा रहे थे',
      other: 'कुछ और',
    },
    byTeam: 'टीम के अनुसार',
    offered: 'ऑफ़र',
    none: 'इस अवधि में कोई चैट पेश नहीं की गई।',
    windowLimited: 'ऑफ़र 90 दिन तक रखे जाते हैं, इसलिए इस अवधि के पुराने दिन नहीं गिने गए।',
  },
  aiDrafts: {
    title: 'समीक्षा के लिए AI ड्राफ़्ट',
    description: 'AI ने भेजने से पहले किसी व्यक्ति के जाँचने के लिए जो ड्राफ़्ट लिखे, और लोगों ने उनके साथ क्या किया।',
    sent: 'भेजे गए',
    sentNote: 'जैसे लिखे थे वैसे या संपादित करके मंज़ूर, {{count}} तय किए गए ड्राफ़्ट में से',
    edited: 'भेजने से पहले संपादित',
    rejected: 'अस्वीकार किए गए',
    rejectReasons: 'ड्राफ़्ट क्यों अस्वीकार किए गए',
    setAsideReasons: 'ड्राफ़्ट क्यों अलग रखे गए',
    reason: 'कारण',
    drafts: 'ड्राफ़्ट',
    noRejects: 'इस अवधि में कोई ड्राफ़्ट अस्वीकार नहीं हुआ।',
    noSetAside: 'इस अवधि में कोई ड्राफ़्ट अलग नहीं रखा गया।',
    rejectNames: {
      inaccurate: 'वह गलत था',
      incomplete: 'कुछ छूट गया था',
      wrong_tone: 'लहजा सही नहीं था',
      not_needed: 'जवाब की ज़रूरत नहीं थी',
      other: 'कुछ और',
    },
    setAsideNames: {
      customer_wrote: 'ग्राहक ने फिर लिखा',
      owner_changed: 'बातचीत किसी और के पास गई',
      answered: 'किसी ने खुद जवाब दिया',
      replaced: 'एक नए ड्राफ़्ट ने उसकी जगह ली',
      resolved: 'बातचीत हल हो गई',
    },
    byAgent: 'AI एजेंट के अनुसार',
    agent: 'AI एजेंट',
    unknownAgent: 'कोई एजेंट दर्ज नहीं',
    none: 'इस अवधि में कोई ड्राफ़्ट नहीं लिखा गया।',
    windowLimited: 'ड्राफ़्ट 90 दिन तक रखे जाते हैं, इसलिए इस अवधि के पुराने दिन नहीं गिने गए।',
  },
  ai: {
    replies: 'AI उत्तर',
    tokens: 'AI टोकन',
    tokensSplit: 'इनपुट {{input}} · आउटपुट {{output}}',
    limitHandoffs: 'सीमा पर व्यक्ति को सौंपी गई',
    limitHandoffsNote: 'वे बातचीत जिन्हें AI नहीं ले सका क्योंकि प्लान या बजट पूरा हो गया था।',
    cache: 'उत्तर कैश हिट दर',
    notMeasured: 'मापा नहीं गया',
    notMeasuredNote:
      'उत्तर कैश ब्रांड और दिन के अनुसार गिनता है; यहाँ कोई लुकअप नहीं हुआ, या यह दृश्य टीम या चैनल के अनुसार है।',
    cacheNote: 'कैश से उत्तर पाए शुरुआती सवालों का हिस्सा (प्रति ब्रांड, UTC दिन)।',
  },
  empty: {
    title: 'इस अवधि में कोई गतिविधि नहीं',
    description: 'कोई और अवधि आज़माएँ या फ़िल्टर हटाएँ।',
    reset: 'तारीख़ें और फ़िल्टर रीसेट करें',
  },
  billing: {
    loading: 'बिलिंग लोड हो रही है',
    plan: 'प्लान: {{plan}}, {{price}} प्रति माह।',
    noPlan: 'इस वर्कस्पेस को कोई प्लान नहीं दिया गया है, इसलिए कुछ भी सीमित नहीं है।',
    alerts: 'इस अवधि के अलर्ट',
    alert: '{{limit}} {{date}} को {{threshold}}% तक पहुँचा।',
    usedOf: '{{max}} में से {{used}}',
    usedUnlimited: '{{used}} उपयोग, कोई सीमा नहीं',
    meterLabel: '{{limit}} का उपयोग',
    perPeriod: 'यह बिलिंग महीना (UTC)।',
    inUse: 'अभी उपयोग में।',
    limits: {
      conversations: 'बातचीत',
      aiReplies: 'AI उत्तर',
      aiTokens: 'AI टोकन',
      knowledgeStorageBytes: 'नॉलेज स्टोरेज',
      seats: 'सीटें',
      webhookEndpoints: 'वेबहुक एंडपॉइंट',
    },
    states: {
      unlimited: 'कोई सीमा नहीं',
      ok: 'सीमा के भीतर',
      warning: 'सीमा के पास',
      reached: 'सीमा पूरी',
    },
    pastDue: {
      title: 'एक इनवॉइस बकाया है',
      description: 'कृपया भुगतान करें, या भुगतान हो चुका हो तो Hamnivo से संपर्क करें।',
    },
    aiPaused: {
      plan_replies:
        'इस महीने के लिए प्लान के AI उत्तर पूरे हो गए हैं। नई बातचीत अगले महीने या बड़े प्लान तक लोगों को जाती है।',
      plan_tokens:
        'इस महीने के लिए प्लान के AI टोकन पूरे हो गए हैं। नई बातचीत अगले महीने या बड़े प्लान तक लोगों को जाती है।',
      budget_tokens:
        'इस महीने का आपका AI बजट पूरा हो गया है। नई बातचीत तब तक लोगों को जाती है जब तक आप बजट न बढ़ाएँ या महीना ख़त्म न हो।',
    },
    usage: {
      title: 'वर्कस्पेस उपयोग',
      period: 'बिलिंग महीना {{from}} से {{to}} तक।',
    },
    budget: {
      title: 'AI बजट',
      description:
        'AI टोकन पर अपनी मासिक सीमा तय करें, प्लान से कम। सीमा पर AI रुक जाता है और बातचीत लोगों को जाती है।',
      tokens: 'मासिक AI टोकन बजट',
      tokensHint: 'प्लान के अलावा कोई बजट न रखने के लिए ख़ाली छोड़ें।',
      alerts: 'मुझे अलर्ट करें',
      threshold: '{{value}}%',
      save: 'बजट सहेजें',
      saved: 'बजट सहेजा गया।',
      readOnly: 'बजट केवल बिलिंग संभालने वाले लोग बदल सकते हैं।',
    },
    invoices: {
      title: 'इनवॉइस',
      empty: 'अभी कोई इनवॉइस नहीं।',
      number: 'इनवॉइस',
      period: 'महीना',
      total: 'कुल',
      status: 'स्थिति',
      due: 'देय तिथि',
      view: 'देखें',
      viewLabel: 'इनवॉइस {{number}} देखें',
      statuses: {
        draft: 'ड्राफ़्ट',
        issued: 'जारी',
        paid: 'भुगतान हुआ',
        void: 'रद्द',
      },
      overdue: 'बकाया',
      paymentFailed: 'भुगतान असफल',
      paidOn: '{{date}} को भुगतान हुआ',
    },
    invoice: {
      title: 'इनवॉइस {{number}}',
      loading: 'इनवॉइस लोड हो रहा है',
      period: '{{plan}} प्लान, {{from}} से {{to}} तक।',
      item: 'मद',
      quantity: 'मात्रा',
      amount: 'राशि',
      planLine: '{{plan}} प्लान',
      meteredLine: 'शामिल {{included}} के बाद {{limit}}',
      total: 'कुल {{amount}}',
      taxNote: 'कर शामिल नहीं हैं।',
    },
  },
};
